
import { useEffect, useRef, useState } from 'react';

export default function TextInput({ defaultValue, onChanged, placeholder, name, type = 'text', disableAutofill = true, autoComplete: autoCompleteProp, ...rest }) {
    // Stable name to avoid changing on each render (which may confuse React/browser)
    const stableName = useRef(name || `no-autofill-${Math.random().toString(36).slice(2)}`);

    // Decide autoComplete attribute for the real input. Prefer explicit prop, otherwise use safe values
    const autoComplete = typeof autoCompleteProp !== 'undefined'
        ? autoCompleteProp
        : (disableAutofill ? (type === 'password' ? 'new-password' : 'off') : undefined);

    const [value, setValue] = useState(defaultValue || '');

    useEffect(() => {
        setValue(defaultValue || '');
    }, [defaultValue]);

    return (
        <>
            {disableAutofill && (
                // Hidden dummy inputs placed before the real input to trap autofill/autocomplete.
                // Browsers often try to fill the first username/password fields they find. These hidden
                // fields (with common autocomplete tokens) reduce the chance the browser fills the visible input.
                <>
                    <input
                        type="text"
                        name="prevent_autofill_username"
                        autoComplete="username"
                        tabIndex={-1}
                        style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}
                        aria-hidden="true"
                        readOnly
                    />
                    <input
                        type="password"
                        name="prevent_autofill_password"
                        autoComplete="new-password"
                        tabIndex={-1}
                        style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}
                        aria-hidden="true"
                        readOnly
                    />
                </>
            )}

            <input
                {...rest}
                type={type}
                name={stableName.current}
                autoComplete={autoComplete}
                value={value}
                onChange={(e) => {
                    const nextValue = e.target.value;
                    setValue(nextValue);
                    if (onChanged) onChanged(nextValue);
                }}
                className='form-control'
                placeholder={placeholder}
            />
        </>
    )
}
